function Comp24() {
    var swiper = new Swiper(".comp-24 .swiper", {
        slidesPerView: "auto",
        spaceBetween: 24,
        centeredSlides: true,
        speed: 600,
    });
}

Comp24();
